export type {
  AvatarGroupItemProps,
  AvatarGroupItemSlots,
  AvatarGroupItemState,
  AvatarGroupItemBaseProps,
  AvatarGroupItemBaseState,
} from './components/AvatarGroupItem/index';
export {
  AvatarGroupItem,
  avatarGroupItemClassNames,
  renderAvatarGroupItem_unstable,
  useAvatarGroupItemStyles_unstable,
  useAvatarGroupItem_unstable,
  useGroupChildClassName,
  useAvatarGroupItemBase_unstable,
} from './components/AvatarGroupItem/index';
